import { ConveyorExtensions as Base } from 'core/extensions/ConveyorExtensions'
import { ConveyorUpdatePayload } from 'stylewhere/api'
import { InboundConveyorApi } from '../api/InboundConveyor'
import { ShippingOperationConfig } from 'core/shared'

export class ConveyorExtensions extends Base {
  static initializeConveyor = async (conveyorId: string, operation: ShippingOperationConfig) => {
    const conveyor = await InboundConveyorApi.getConveyor(conveyorId)
    const payload: ConveyorUpdatePayload = {
      id: conveyorId,
      operation: operation,
      creationDate: conveyor.creationDate,
      lastModifyDate: conveyor.lastModifyDate,
      description: conveyor.description,
      externalId: conveyor.externalId,
      zone: conveyor.zone,
      user: conveyor.user,
      settings: conveyor.settings,
      attributes: conveyor.attributes
    }
    await InboundConveyorApi.changeConveyor(payload)
  }
}
